import { useDispatch } from "react-redux";
import "@features/background/background.scss";
import "./get-subscribe-popup.scss";

import { Message } from "@features";
import { Text, Button, Icon } from "@ui-kit";
import { Bot } from "@entities/dtos";
import { userSetModalSubscribeShowAC } from "@entities/user/model/user.actions";
const CloseIcon = "/images/icons/x-gray700.svg";

const GetSubscribePopup = () => {
  const dispatch = useDispatch();
  const botMessages = new Bot().getSubscribeMessages("benefits");

  const onBackgroundClick = (e) => {
    if (e.target.id === "free-product-background") {
      return onCancel();
    }
  };

  const onCancel = () => {
    return dispatch(userSetModalSubscribeShowAC({ show: false, product: {} }));
  };

  const onSubscribe = () => {
    dispatch(userSetModalSubscribeShowAC({ show: false, product: {} }));
    window.open(`/#prices`, "_blank");
  }

  return (
    <div
      id="free-product-background"
      className="background-default free-product-popup__bkg"
      onMouseDown={onBackgroundClick}
    >
      <div className="free-popup__wrapper">
        <div className="free-popup__actions">
          <div className="free-popup__close" onClick={onCancel}>
            <Icon src={CloseIcon} />
          </div>
        </div>

        {botMessages.map((message, index) => (
          <Message
            isUser={true}
            ownerId={null}
            message={message}
            key={`message-${index}`}
          />
        ))}

          <div className="free-product-popup__actions">
            <Button
              onClick={onSubscribe}
            >
              Starting at $1999 per month 
            </Button>
          </div>

        <div className="free-popup__info">
          <ul className="list">
            <li>
              <Text as="h5">Unlimited gallery access</Text>
            </li>
            <li>
              <Text as="h5">Lifetime commercial rights</Text>
            </li>
            <li>
              <Text as="h5">New illustrations added every month</Text>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default GetSubscribePopup;
